import SmsScreen from "components/shared/SmsScreen"
import { MULTIPLE_ACCOUNTS_FOUND_TEXT } from "shared/constants"
import { useHistory } from "react-router-dom"
import { useMutation } from "@apollo/client"
import { clearOnLogout } from "apolloClient"
import { errorsVar } from "cache"
import FullPageLoader from "components/shared/FullPageLoader"
import {
  useForceAuthEffect,
  useVerificationRedirectEffect
} from "components/Login/hooks"
import { Account } from "components/Login/operations"
import ErrorToast from "components/shared/ErrorToast"
import peopleIcon from "./assets/people-icon.svg"
import { ConfirmSmsVerification, Logout } from "./operations"

import styles from "./MultipleAccountsFound.module.scss"

const MultipleAccountsFound = () => {
  useForceAuthEffect({ authUrl: "/login" })
  useVerificationRedirectEffect()
  const history = useHistory()

  const [logoutUser, { client }] = useMutation(Logout)
  const [confirmSmsVerification, { loading }] = useMutation(
    ConfirmSmsVerification,
    {
      refetchQueries: [
        {
          query: Account,
          variables: { rsvpPortalId: process.env.REACT_APP_RSVP_PORTAL_ID }
        }
      ],
      onCompleted: ({ confirmSmsVerification: result }) => {
        const { success, errors } = result
        if (success) {
          errorsVar(null)
          history.replace("/sms-success")
        } else {
          errorsVar(errors)
        }
      }
    }
  )

  const logout = () => {
    clearOnLogout(client)
    logoutUser({
      variables: {
        input: {}
      }
    })
  }

  const handleVerifyAccount = () => {
    confirmSmsVerification({
      variables: {
        input: {}
      }
    })
  }

  const handleReturnToLogin = () => {
    logout()
    history.replace("/login")
  }

  if (loading) {
    return <FullPageLoader />
  }

  return (
    <>
      <SmsScreen
        heading={MULTIPLE_ACCOUNTS_FOUND_TEXT.heading}
        description={MULTIPLE_ACCOUNTS_FOUND_TEXT.description}
        icon={peopleIcon}
        iconClassName={styles.peopleIcon}
        showBackButton
        buttons={[
          {
            text: MULTIPLE_ACCOUNTS_FOUND_TEXT.yesButton,
            primary: true,
            onClick: handleVerifyAccount,
            disabled: loading
          },
          {
            text: MULTIPLE_ACCOUNTS_FOUND_TEXT.noButton,
            outline: true,
            onClick: handleReturnToLogin
          }
        ]}
        disclaimer={MULTIPLE_ACCOUNTS_FOUND_TEXT.disclaimer}
      />
      <ErrorToast />
    </>
  )
}

export default MultipleAccountsFound
